import React from 'react';

function Sidebar({ activeItem, onItemClick }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <svg width="40" height="32" viewBox="0 0 25 20" fill="none" style={{ color: '#1a2e58' }}>
          <path fill="currentColor" fillRule="evenodd" d="M5.638 5.952c.96-.196 1.566-.728 1.743-1.357.192-.686.753-1.19 1.566-1.413.798-.21 1.758-.112 2.644.237.813.322 1.714.392 2.393.126.902-.363 1.108-1.245.517-2.084-.738-1.05-2.393-1.665-3.619-1.4-.65.155-1.063.518-1.167.994-.118.56-.665.993-1.433 1.19l-.059.013c-.783.196-1.758.126-2.615-.224-.738-.307-1.61-.405-2.393-.237C1.68 2.147 1 3.46 1.96 4.707c.768.979 2.348 1.51 3.678 1.245M19.45 10.19c-.812.238-1.255.853-1.27 1.609-.03.867-.488 1.609-1.315 1.986l-.06.029c-.856.391-1.964.35-3.042-.085-.975-.391-2.068-.405-2.955.085-1.211.671-1.699 2.238-.975 3.749.975 2.043 3.472 3.008 5.215 2.084.872-.475 1.33-1.315 1.36-2.252.029-1.05.575-1.86 1.432-2.266.827-.406 1.89-.406 2.925.042.901.391 1.832.433 2.526.07 1.285-.686 1.123-2.49-.236-3.848-1.034-.993-2.541-1.51-3.605-1.203m-1.654-6.38c-.768.154-1.182.658-1.182 1.287 0 .56-.296 1.022-.916 1.232l-.162.055c-.621.21-1.448.14-2.202-.21-.797-.363-1.713-.475-2.481-.237-.783.238-1.256.797-1.36 1.469-.088.657-.576 1.203-1.344 1.455l-.207.07c-.782.266-1.713.154-2.555-.224-.96-.434-2.142-.518-3.176-.098C.88 9.156.157 10.499.66 11.828c.694 1.819 3.072 2.728 4.963 1.987 1.005-.392 1.61-1.162 1.743-2.015.118-.784.665-1.4 1.448-1.693l.103-.042c.769-.28 1.714-.21 2.556.196.886.42 1.906.518 2.718.196.798-.308 1.197-.938 1.197-1.665 0-.658.37-1.175 1.004-1.4l.074-.027c.62-.224 1.433-.14 2.201.21.813.363 1.684.475 2.334.21 1.152-.448 1.123-1.805-.059-2.897-.857-.811-2.186-1.259-3.146-1.077" clipRule="evenodd"/>
        </svg>
      </div>

      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          <li>
            <button
              className={`sidebar-item ${activeItem === 'insights' ? 'active' : ''}`}
              onClick={() => onItemClick('insights')}
            >
              <svg className="sidebar-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
                <path d="M12 2v4M22 9.27h-4M2 9.27h4M18.18 21.02l-2.83-2.83M5.82 21.02l2.83-2.83"/>
              </svg>
              <span className="sidebar-label">AI Insights</span>
            </button>
          </li>
          <li>
            <button
              className={`sidebar-item ${activeItem === 'metrics' ? 'active' : ''}`}
              onClick={() => onItemClick('metrics')}
            >
              <svg className="sidebar-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="3" y="12" width="4" height="9" rx="1"/>
                <rect x="10" y="8" width="4" height="13" rx="1"/>
                <rect x="17" y="4" width="4" height="17" rx="1"/>
              </svg>
              <span className="sidebar-label">Metrics</span>
            </button>
          </li>
          <li>
            <button
              className={`sidebar-item ${activeItem === 'surveys' ? 'active' : ''}`}
              onClick={() => onItemClick('surveys')}
            >
              <svg className="sidebar-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="4" y="2" width="16" height="20" rx="2"/>
                <path d="M8 6h8M8 10h8M8 14h5"/>
                <path d="M9 18l2 2 4-4"/>
              </svg>
              <span className="sidebar-label">Surveys</span>
            </button>
          </li>
          <li>
            <button
              className={`sidebar-item ${activeItem === 'automation' ? 'active' : ''}`}
              onClick={() => onItemClick('automation')}
            >
              <svg className="sidebar-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
              </svg>
              <span className="sidebar-label">Automation</span>
            </button>
          </li>
        </ul>
      </nav>

      <div className="sidebar-bottom">
        <ul className="sidebar-menu">
          <li>
            <button
              className={`sidebar-item ${activeItem === 'settings' ? 'active' : ''}`}
              onClick={() => onItemClick('settings')}
            >
              <svg className="sidebar-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/>
              </svg>
              <span className="sidebar-label">Settings</span>
            </button>
          </li>
          <li>
            <button
              className={`sidebar-item ${activeItem === 'help' ? 'active' : ''}`}
              onClick={() => onItemClick('help')}
            >
              <svg className="sidebar-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                <circle cx="12" cy="17" r="0.5" fill="currentColor"/>
              </svg>
              <span className="sidebar-label">Help</span>
            </button>
          </li>
        </ul>
      </div>
    </aside>
  );
}

export default Sidebar;
